<template>
  <div class="fair-item">
    <div class="fair-item__banner" @click="viewDetail(jobFairInfo)">
      <img :src="jobFairInfo.minBackgroundUrl || $noPic">
    </div>
    <div class="fair-item__content" @click="viewDetail(jobFairInfo)">
      <div class="fair-title">{{ jobFairInfo.name }}</div>
      <div class="fair-info text-comma">
        <span>已有 <b class="catchEye">{{ jobFairInfo.enterpriseCount }}</b> 家企业参会</span>
        <span>已有 <b class="catchEye">{{ jobFairInfo.positionCount }}</b> 个职位</span>
        <span v-if="false">已有 <b class="catchEye">{{ jobFairInfo.personCount }}</b> 名求职者预约</span>
        <span v-show="jobFairInfo.type === 1">已有 <b class="catchEye">{{ jobFairInfo.enterCount }}</b> 人进场</span>
        <span v-if="jobFairInfo.status == 2">火速报名中……</span>
      </div>
      <div class="fair-item__content-text">
        <p>主办方：{{ jobFairInfo.organizer }}</p>
        <p v-if="jobFairInfo.undertakeUnit">
          承办方：{{ jobFairInfo.undertakeUnit }}
        </p>
        <p v-if="jobFairInfo.cooperativeUnit">
          协办方：{{ jobFairInfo.cooperativeUnit }}
        </p>
        <template v-if="jobFairInfo.startTime">
          <p >
            报名时间：
            {{ jobFairInfo.registerStartTime }}
            至
            {{ jobFairInfo.registerEndTime }}
            （星期{{ jobFairInfo.registerEndTime | transformDateToWeek }}）
          </p>
          <p>
            举办日期：
            {{ jobFairInfo.startTime }}
            至
            {{ jobFairInfo.endTime }}
            （星期{{ jobFairInfo.endTime | transformDateToWeek }}）
          </p>
          <p v-if="jobFairInfo.type != 3">
            举办地址：{{ jobFairInfo.address }}
          </p>
        </template>
      </div>
    </div>
    <div class="fair-item__btn buttons">
      <el-button v-if="from === '2' && !jobFairDisabled"
                 :disabled="jobFairDisabled" type="warning" @click="
                   toBooth(jobFairInfo.type, jobFairInfo.id, jobFairInfo.isAbleBooth)
                 ">
        展位预订
      </el-button>
      <!--4表示代理招聘-->
      <el-button v-show="
                   jobFairInfo.type == 1 && from === '2' && jobFairInfo.status === 2
                 " :disabled="jobFairInfo.status != 2" type="primary"
                 class="blue-bg" @click="toBooth(4, jobFairInfo.id, true)">
        代理招聘
      </el-button>
      <el-button v-if="from === '2'" type="success" @click="
        $router.push({
          path: '/jobFair/detail/' + jobFairInfo.id,
          query: {
            from: '2',
          },
        })
      ">
        参会企业
      </el-button>
    </div>
    <jobFairStatus :status="jobFairInfo.status" />
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import jobFairStatus from '@/model/jobFairStatus'
import {
  judyStatus
} from '@/assets/js/enterprise/index.js'
export default {
  filters: {
    transformDateToWeek(value) {
      return ['日', '一', '二', '三', '四', '五', '六'][new Date(value).getDay()]
    }
  },
  props: {
    jobFairInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    // 1,定展头部预告Item；2招聘会列表；3我的招聘会
    from: {
      type: String,
      default () {
        return ''
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.base.userInfo
    }),
    jobFairDisabled() {
      if (!this.jobFairInfo.startTime) {
        return this.jobFairInfo.status !== 4
      } else {
        return this.jobFairInfo.status !== 2
      }
    }
  },
  methods: {
    // 预定展位
    toBooth(type, id, isAbleBooth) {
      judyStatus(() => {
        if (
          this.userInfo['proxyRecruitCount'] &&
            this.userInfo['proxyRecruitCount'] <=
            this.userInfo['useProxyRecruitCount'] &&
            type === 4
        ) {
          this.$message.warning('套餐中代理招聘服务次数已经不足，请升级套餐')
          return
        }
        if (!isAbleBooth && type === 1) {
          this.$message.warning(
            '抱歉，人才港招聘会上半场和下半场只能够预定一场'
          )
          return
        }
        if (this.userInfo['type'] != 0) {
          this.$router.push('/jobFair/booth/' + id + '/' + type)
        } else {
          this.$api.getPositionList({
            type: 1
          }, (res) => {
            if (res.length) {
              this.$router.push('/jobFair/booth/' + id + '/' + type)
            } else {
              this.$router.push('/jobFair/emptyPosition')
            }
          })
        }
      }, 'jobFair')
    },
    viewDetail(jobFairInfo) {
      if (this.from === '3') {
        this.$emit('viewDetail', jobFairInfo.id)
        return
      }
      let id = this.from === '1' ? jobFairInfo.activityId : jobFairInfo.id
      this.$router.push({
        path: '/jobFair/detail/' + id,
        query: {
          from: '1'
        }
      })
    }
  },
  components: {
    jobFairStatus
  }
}

</script>

<style type="text/scss" lang="scss" scoped>
  @import "@/assets/css/buttons.scss";
@import "@/assets/css/enterprise_color.scss";
.fair-item {
  padding: 25px 350px 30px 20px;
  margin-top: 10px;
  // height: 240px;
  background-color: #fff;
  position: relative;
  overflow: hidden;

  &:hover {
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
  }

  &__banner {
    float: left;
    padding-top: 8px;
    overflow: hidden;
    width: 230px;
    height: 180px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  &__content {
    margin-left: 255px;

    .fair-title {
      font-size: 16px;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 30px;
      font-weight: bold;
    }

    .fair-info {
      color: #666;
      font-size: 14px;
      line-height: 25px;

      i {
        font-style: normal;
      }

      .catchEye {
        color: #f60;
        font-size: 16px;
      }
    }

    &-text {
      font-size: 14px;
      color: #666;
      line-height: 2;
    }
  }

  &__btn {
    position: absolute;
    right: 60px;
    top: 50%;
    margin-top: -70px;
    line-height: 140px;

  }
}
</style>



// WEBPACK FOOTER //
// src/model/jobFairItem.vue